import queries from '@apis/queries';
import Accordion from '@components/Accordion';
import PdfViewer from '@components/PdfViewer';
import Text from '@components/Text';
import styled from '@emotion/styled';
import { TermCategoryRow } from '@models/term/termCategory';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';

interface Props {
    termCategory: TermCategoryRow;
}

function TermAccordion({ termCategory }:Props) {
    const { title, id } = termCategory;
    const { data: term } = useQuery(queries.terms.main(id));
    //  로드 시 자식의 변경을 위해 사용
    const [numPages, setNumPages] = useState<number>(0);
    return (
        <Accordion title={<Text fontWeight='bold'
            size='lg'>{title}</Text>} >
            {term?.fileUrl && (
                <PdfViewer fileUrl={term.fileUrl}
                    onLoad={setNumPages} />
            )}
            <Hidden>{numPages}</Hidden>
        </Accordion>
    );
}

const Hidden = styled.div`
    display: none;
`;

export default TermAccordion;
